export enum REASONS_CATEGORIES {
  CLOSE_ALL_CATEGORY = 'Закрыть всё',
}
